import React from 'react'
import ImageMapRenderer from "./image_map_renderer";
import {
  Route,
  useRouteMatch,
} from "react-router-dom";

export default function ExhibitionDefaultRouting({children, customImageMapRenderer, AddonRenderer, ...props}) {
  const DynamicImageMapRenderer = customImageMapRenderer || ImageMapRenderer
  const isImageMapHotspotIdRoute = useRouteMatch("/image_map/:imageMapIdParam/hsi/:preselectedHotspotIdParam")
  const isImageMapHotspotIdentifierRoute = useRouteMatch("/image_map/:imageMapIdParam/hs/:preselectedHotspotIdentifierParam")

  return <>
    <Route path="/imgi/:imageMapIdentifierParam/hs/:preselectedHotspotIdentifierParam" exact>
      <DynamicImageMapRenderer
        AddonRenderer={AddonRenderer}/>
    </Route>

    <Route path="/imgi/:imageMapIdentifierParam/hsi/:preselectedHotspotIdParam" exact>
      <DynamicImageMapRenderer
        AddonRenderer={AddonRenderer}/>
    </Route>

    <Route path="/image_map/:imageMapIdParam/hsi/:preselectedHotspotIdParam" exact>
      <DynamicImageMapRenderer
        AddonRenderer={AddonRenderer}/>
    </Route>

    <Route path="/image_map/:imageMapIdParam/hs/:preselectedHotspotIdentifierParam" exact>
      <DynamicImageMapRenderer
        AddonRenderer={AddonRenderer}/>
    </Route>

    <Route path="/imgi/:imageMapIdentifierParam" exact>
      <DynamicImageMapRenderer
        AddonRenderer={AddonRenderer}/>
    </Route>

    {!isImageMapHotspotIdRoute && !isImageMapHotspotIdentifierRoute && <Route path="/image_map/:imageMapIdParam" >
      <DynamicImageMapRenderer
        AddonRenderer={AddonRenderer}/>
    </Route>}

    <Route path="/" exact>
      <DynamicImageMapRenderer
        AddonRenderer={AddonRenderer}
        imageMapIdentifier={"entrance_lobby"}/>
    </Route>
  </>
}

      